
$('body').on('click', '.js-open-search-popup', function (){
  $('.js-search-popup').fadeIn(function(){ $('.js-search-input').focus() })
})

$('body').on('click', '.close-search-popup', function(){
  $('.js-search-popup').fadeOut()
})


$(document).keyup(function(e) {
  if (e.key === "Escape") { // escape key maps to keycode `27`
    $('.js-search-popup').fadeOut()
  }
});

$('body').on('click', function(event) {
  let $target = $(event.target);
  if($target.hasClass('js-close-search-target')) {
    $('.js-search-popup').fadeOut()
  }
})